export * from './SelectedProductsSidebarFooter.types';
export { default as SelectedProductsSidebarFooter } from './SelectedProductsSidebarFooter';
